import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const ChampagneGlasses = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m6.047 18.958.862-4.644m0 0c1.71.318 3.603-2.16 4.229-5.533.222-1.33.34-2.675.353-4.023L6.062 3.75a26 26 0 0 0-1.114 3.882c-.627 3.377.251 6.364 1.961 6.682M4.5 18.67l3.095.575m10.021 1.326-.539-4.692m0 0c1.728-.198 2.811-3.122 2.42-6.53a26 26 0 0 0-.843-3.95l-5.487.63a26 26 0 0 0 .074 4.038c.391 3.412 2.108 6.01 3.836 5.812m-1.025 4.871 3.127-.359M6.307 9.364s3.423.024 4.886-1.605m8.331 2.502s-3.422.024-4.885-1.605"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(ChampagneGlasses) as SvgIcon;
export { ForwardRef as ReactComponent };
